import React from "react";
import "./ServiceHighlights.css";
import p1 from "../assets/pakistan-flag.png";
import p2 from "../assets/paint-roller.png";
const highlights = [
  {
    image: p1, 
    title: "Serving Pakistan’s Major Cities Online",
    description:
      "Our online store delivers to all major Pakistani cities, with express delivery available in Sindh Province including Karachi, Hyderabad, and surrounding areas. Experience the convenience of having the best wall paints in Pakistan delivered directly to your project site.",
  },
  {
    image: p2, 
    title: "Quality Assurance Promise",
    description:
      "Every paint product ordered through our online store comes with our quality assurance guarantee. If you’re not completely satisfied with your Glamur Paints purchase, our customer service team will make it right.",
  },
];

const ServiceHighlights = () => {
  return (
    <section className="highlights-section">
      <div className="highlights-container">
        {highlights.map((item, index) => (
          <div key={index} className="highlight-card">
            <img src={item.image} alt={item.title} className="highlight-img" />
            <div className="highlight-content">
              <h3 className="highlight-title">{item.title}</h3>
              <p className="highlight-desc">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceHighlights;
